var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOverlap = function SvgOverlap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10.314,
    height: 10.314,
    x: 8.781,
    y: 12,
    stroke: "#000",
    rx: 0.5,
    transform: "rotate(-45 8.781 12)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10.314,
    height: 10.314,
    x: 2.152,
    y: 12,
    stroke: "#000",
    rx: 0.5,
    transform: "rotate(-45 2.152 12)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M14.547 10.035h-3.57M16.39 11.92H9.133M14.86 13.807h-4.2"
  })));
};
export default SvgOverlap;